export const GLOBAL_API_INSTITUTIONS_ENDPOINTS = {
  getInstitutionsCountries: (currency?: string) =>
    `/institutions/countries?institution${currency ? `[currency]=${currency}` : ''}`,
  getInstitutionsList: '/institutions',
  getInstitutionDetails: (institutionId: string) =>
    `/institutions/${institutionId}`,
} as const;
